import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { deepCoalesce } from '../../../common/helpers';

export default function SettledTxnSelectionCell(props) {
  const {
    pendingTransaction,
    selectionSet,
    setSelectionSet,
  } = props;

  if (!pendingTransaction) {
    return null;
  }

  if (pendingTransaction.quantity > 0) {
    return null;
  }

  let disabled = selectionSet.length > 0
    && selectionSet[0].currency !== pendingTransaction.currency;
  if (deepCoalesce(pendingTransaction, ['brokerOrder', 'csbrokerorder', 'transferAdviceFile'])) {
    disabled = true;
  }

  const isSelected = selectionSet.findIndex(element => element.id === pendingTransaction.id) > -1;
  const key = `${pendingTransaction.id}-${isSelected}-${
    selectionSet.length > 0 ? selectionSet[0].currency : '___'
  }`;
  return (
    <Checkbox
      style={{ padding: '0px' }}
      checked={isSelected}
      key={key}
      disabled={disabled}
      size="small"
      color="primary"
      inputProps={{ 'aria-label': 'primary checkbox' }}
      onChange={(e) => {
        if (e.target.checked) {
          const newSelectionSet = [...selectionSet, pendingTransaction];
          setSelectionSet(newSelectionSet);
        } else {
          const indexIn = selectionSet.findIndex(
            element => element.id === pendingTransaction.id,
          );
          if (indexIn > -1) {
            selectionSet.splice(indexIn, 1);
            setSelectionSet([...selectionSet]);
          }
        }
      }}
    />
  );
}
